import { defineMessages } from 'react-intl';

export const deliveryMessages = defineMessages({
  DEFAULT: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Service & Versandkosten</link>',
    id: 'taxHint.text.carrierDelivery.default',
  },
  L: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Speditionsgebühr</link>',
    id: 'taxHint.text.carrierDelivery.l',
  },
  S: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Speditionsgebühr</link>',
    id: 'taxHint.text.carrierDelivery.s',
  },
});

export const deliveryMessagesDialogTitle = defineMessages({
  DEFAULT: {
    defaultMessage: 'Service & Versandkosten',
    id: 'taxHint.dialog.headline.default',
  },
  L: {
    defaultMessage: 'Speditionsgebühr',
    id: 'taxHint.dialog.headline.l',
  },
  S: {
    defaultMessage: 'Speditionsgebühr',
    id: 'taxHint.dialog.headline.s',
  },
});

export const deliveryMessagesDialogContent = defineMessages({
  dialogContent: {
    defaultMessage:
      'Je Bestellung und Lieferanschrift zahlen Sie für Standardlieferungen 6 € Versandkosten (unabhängig vom Bestellwert).',
    id: 'taxHint.dialog.text',
  },
});
